const State = state => {
  return {
    system: state.System
  };
};
export default State;
